'use strict';
angular.module('util.trsMapScaleModule', [])
    .directive('trsMapScale', ["$q", "$timeout", function($q, $timeout) {
        return {
            scope: {
                // stageNum: "@", //进度数量 
                stage: "=" //进度
            },
            restrict: "E",
            templateUrl: "./components/util/trsMapScale/trsMapScale.html",
            link: function(scope, iElm, iAttrs, controller) {
                var contentHtml, btn, bar, step, g, b, m, oneWidth, progressbar;
                 
                function initStatus() {
                    scope.progressArr = [];
                    oneWidth = 10; //单个进度格的宽度
                }

                function init() {
                    btn = iElm.find(".m-panebtn")[0];
                    bar = iElm.find(".m-paneul")[0];
                    progressbar = iElm.find(".progressbar")[0];
                    g = document;
                    b = window;
                    m = Math;
                    scope.stageNum = 17; //进度数量 
                    initProgress();
                    var promise;
                    calcu(
                        function(to) {
                            $timeout(function() {
                                scope.stage = m.floor(to / oneWidth);
                            });
                        }
                    );
                }
                scope.$watch("stage", function(newV) {
                    if (newV!==undefined) {
                        initStatus();
                        init();
                    }else{
                        scope.stage = 5;
                    }
                });
                /**
                 * [initProgress description] 初始化进度条
                 * @return {[type]} [description]
                 */
                function initProgress() {
                    var temp = false;
                    for (var i = 0; i < scope.stageNum; i++) {
                        temp = (i < scope.stage) ? true : false;
                        scope.progressArr.push({ select: temp });
                    }
                    progressbar.style.width = scope.stage * oneWidth + 'px';
                    btn.style.left = scope.stage * oneWidth + 'px';
                }

                /**
                 * [calcu description] 拖动进度条
                 * @param  {Function} callback [description]
                 * @return {[type]}            [description]
                 */
                function calcu(callback) {
                    btn.onmousedown = function(e) { //按钮
                        var x = (e || b.event).clientX; // e 或者 window 的clientX （整体偏移）
                        var l = btn.offsetLeft; // 偏移距离
                        var max = bar.offsetWidth - btn.offsetWidth; //  最大偏移距离
                        var min = 0;
                        g.onmousemove = function(e) {
                            var thisX = (e || b.event).clientX; //整体偏移
                            var to = m.min(max, m.max(0, l + (thisX - x)));
                            to = to < 0 ? 0 : to;
                            btn.style.left = to + 'px';
                            progressbar.style.width = to + 'px';
                            callback(to);
                            g.onmouseup = function() {
                                g.onmousemove = null;
                            };
                        };
                    };
                }
                /**
                 * [addprogess description]
                 * @param  {[type]} step [description]
                 * @return {[type]}      [description]
                 */
                scope.addprogess = function(step) {
                    var max = bar.offsetWidth - btn.offsetWidth; //  最大偏移距离
                    var min = 0;
                    var to = parseInt(btn.style.left) + parseInt(step) * oneWidth;
                    to = to > max ? max : (to < min ? min : to);
                    btn.style.left = to + 'px';
                    progressbar.style.width = to + 'px';
                    scope.stage = m.floor(to / oneWidth);
                };
            }
        };
    }]);